/**
 * Aerocivil aviation radar — client constants (Milestone A2 — attribution contract, not live UI).
 * @see docs/weather/aerocivil-radar-approval.md
 */
import { isAerocivilPublicRolloutAllowed } from "./aerocivilProductionRolloutConfig.js";

export const AEROCIVIL_AVIATION_RADAR_SOURCE_CODE = "AEROCIVIL_AVIATION_RADAR";
export const AEROCIVIL_AVIATION_RADAR_SOURCE_KEY = "aerocivil_aviation_radar";
export const AEROCIVIL_AVIATION_RADAR_LABEL = "Aerocivil aviation radar";
export const AEROCIVIL_AVIATION_RADAR_TRUST_LABEL = "Official (aeronautical)";
export const AEROCIVIL_AVIATION_RADAR_TYPE_LABEL = "Official aeronautical radar";
export const AEROCIVIL_AVIATION_RADAR_COVERAGE_LABEL =
  "Colombia aeronautical radar sites (Bogotá GTA, national CRM mosaic, ADZ)";
export const AEROCIVIL_AVIATION_RADAR_ATTRIBUTION =
  "Radar imagery: Aerocivil — Meteorología Aeronáutica para Colombia.";
export const AEROCIVIL_AVIATION_RADAR_ATTRIBUTION_ES =
  "Imagen de radar: Aerocivil — Meteorología Aeronáutica para Colombia.";
export const AEROCIVIL_AVIATION_RADAR_FEATURE_FLAG_ENV = "REACT_APP_AEROCIVIL_RADAR_ENABLED";

export function isAerocivilAviationRadarPublicUiEnabled() {
  return isAerocivilPublicRolloutAllowed();
}
